var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adobe-pdf"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"height":"560px","width":"100%"},attrs:{"id":"adobe-dc-view"}}),(_vm.error)?_c('p',{staticClass:"adobe-pdf__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }